export const colorPalette = [
  '#FFADAD', // Red
  '#A2D2FF', // Light Blue
  '#A8E6CF', // Mint Green
  '#FFDAC1', // Peach
  '#EFD9CE', // Beige
  '#CDB4DB', // Lavender
  '#FEC8D8', // Light Pink
  '#D4A5A5', // Soft Red
  '#BDE0FE', // Pastel Blue
  '#A7C7E7', // Soft Blue
  '#FFB77A', //orange
  '#FFEB3B', // Pastel yello (new color)
]

/** Brand palette for redesigned analysis pages (navy / teal / amber / coral). */
export const analysisColorPalette = [
  '#00146D', // navy
  '#0D9B87', // teal
  '#076B5C', // deep teal
  '#C98A16', // amber
  '#D14A3E', // coral
  '#5F7484', // slate
  '#3D5A80', // blue-slate
  '#2A9D8F', // sea
  '#E9C46A', // sand
  '#264653', // dark teal
  '#8A9BA7', // muted
  '#0B1E2D', // ink
]

export const getScoreColor = (score: number) => {
  if (score >= 3) return '#10b981'
  if (score >= 2) return '#f59e0b'
  return '#ef4444'
}
